import * as Types from "../action/types";

const counterReducer = (
  state = { cartItems: [], totalItem: 0, totalAmount: 0 },
  action
) => {
  switch (action.type) {
    case Types.PRODUCT_ADD:
      const item = action.payload;
      const isExits = state.cartItems.find((i) => i.id === item.id);
      if (isExits) {
        let update = state.cartItems.map((i) => {
          if (i.id === isExits.id) {
            return {
              ...i,
              qty: i.qty + 1,
            };
          }
          return i;
        });
        return { ...state, cartItems: update };
      } else {
        return {
          ...state,
          cartItems: [...state.cartItems, item],
        };
      }
    case Types.PRODUCT_DECREMENT:
      const items = action.payload;
      const isExitss = state.cartItems.find((i) => i.id === items.id);
      if (isExitss) {
        let update = state.cartItems.map((i) => {
          if (i.id === isExitss.id) {
            return {
              ...i,
              qty: i.qty - 1,
            };
          }
          return i;
        });
        return { ...state, cartItems: update };
      } else {
        return {
          ...state,
          cartItems: [...state.cartItems, item],
        };
      }

    case Types.GET_TOTAL_ITEM:
      let { totalItem, totalAmount } = state.cartItems.reduce(
        (total, current) => {
          let { price, qty } = current;
          let updateTotalPrice = price * qty;
          total.totalAmount += updateTotalPrice;
          total.totalItem += qty;
          return total;
        },
        { totalItem: 0, totalAmount: 0 }
      );
      return { ...state, totalItem, totalAmount };

    default:
      return state;
  }
};

export default counterReducer;
